import { Checkbox, Flex, Text } from "@chakra-ui/react";
import { Icon } from "@pufflig/prompt-studio-ui";

interface OnboardingListItemProps {
  steps: any[];
  title: string;
  duration: string;
  isCompleted: boolean;
  onClick: () => void;
}

export const OnboardingListItem = (props: OnboardingListItemProps) => {
  const { title, duration, steps, isCompleted, onClick } = props;
  return (
    <Flex
      onClick={onClick}
      cursor="pointer"
      paddingY="2"
      paddingX="3"
      width="100%"
      background="background.primary"
      borderRadius="0.5rem"
      color="foreground.primary"
      justifyContent="space-between"
      _hover={{
        background: "background.secondary",
      }}
    >
      <Flex direction="column" gap="0.25rem">
        <Flex gap="0.5rem">
          <Checkbox readOnly isChecked={isCompleted} cursor="default" borderColor="foreground.secondary" />
          <Text textStyle="label/M/medium">{title}</Text>
        </Flex>
        <Text color="foreground.secondary">
          {steps.length} steps • {duration}
        </Text>
      </Flex>
      <Flex alignItems="center">
        <Icon name="arrow-down-1" size="lg" />
      </Flex>
    </Flex>
  );
};
